import { EntityTypes } from 'models/entity';

export default class AIEntityInstructionDTO {
  tenantId?: string;

  isoNormId?: number;

  entityType: EntityTypes;

  code?: string;

  instruction: string;

  constructor() {
    this.entityType = EntityTypes.Link;
    this.instruction = '';
  }
}
